import React, { FunctionComponent } from 'react';
import { Button } from 'antd';
import styles from './authForm.module.scss';

interface SubmitButtonProps {
  label: string;
  busyLabel: string;
  busy: boolean;
}

/**
 * Główny przycisk formularza. W trakcie wysyłania nie dostaje `disabled` (czytnik ekranu zgubiłby
 * fokus), tylko `aria-disabled` + wskaźnik; komunikat o stanie idzie przez `role="status"`.
 * Ponowne wysłanie blokuje formularz (`busy` w obsłudze `onFinish`).
 */
const SubmitButton: FunctionComponent<SubmitButtonProps> = ({ label, busyLabel, busy }) => (
  <>
    <Button type="primary" htmlType="submit" block loading={busy} aria-disabled={busy || undefined}>
      {busy ? busyLabel : label}
    </Button>
    <span className={styles.srOnly} role="status">
      {busy ? busyLabel : ''}
    </span>
  </>
);

export default SubmitButton;
